import { h } from "preact";
import { FulfillmentSettingsTracking, } from "restaumatic-client";
import Switch from "../../components/Switch";
import { observer } from "mobx-react";
import { t, translate } from "../../I18n";
function FulfillmentMethodSwitcher(props) {
    const { controller, options, isFrame } = props;
    const switchExtraClass = isFrame ? "m-switch--frame" : "";
    return (h(Switch, { name: "fulfillmentMethod", label: translate(t.order.delivery_method), controller: controller, options: options, onChange: () => FulfillmentSettingsTracking.chooseMethodEvent(controller.value, {
            tag: "Menu",
        }), extraClass: switchExtraClass }));
}
export default observer(FulfillmentMethodSwitcher);
